import React, { useEffect, useMemo, useState } from "react";
import { compareAsc, format, parseISO } from "date-fns";
import ScheduleItem from "./ScheduleItem";
import { VenueSession } from "../../app/types";
import now from "../../util/now";
import SegmentSelector from "../common/SegmentSelector";
import LightTheme from "../theme/LightTheme";
import useSessionsByDate, {
  ScheduleDateFormat,
} from "../utils/useSessionsByDate";

const Schedule = () => {
  const sessionsByDate = useSessionsByDate();
  const [activeIndex, setActiveIndex] = useState(0);

  const labels = useMemo(
    () =>
      Object.keys(sessionsByDate).sort((a, b) =>
        compareAsc(
          parseISO(
            (sessionsByDate[a] as VenueSession[])[0].startTime ??
              "1970-01-01T00:00:00Z",
          ),
          parseISO(
            (sessionsByDate[b] as VenueSession[])[0].startTime ??
              "1970-01-01T00:00:00Z",
          ),
        ),
      ),
    [sessionsByDate],
  );

  useEffect(() => {
    const nowString = format(now, ScheduleDateFormat);
    const index = labels.findIndex((dayString) =>
      dayString.includes(nowString),
    );
    if (index > 0) {
      setActiveIndex(index);
    }

    // Only needs to run on mount
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const sessions = useMemo(
    () => sessionsByDate[labels[activeIndex]],
    [activeIndex, labels, sessionsByDate],
  );

  return (
    // ID needed for sidebar navigation
    <div id="schedule" className="scheduleContainer">
      <div className="scheduleHeaderWrapper">
        <div className="scheduleHeader">
          <h1 id="scheduleTitle">Event Schedule</h1>
        </div>
      </div>
      <div className="content">
        <div className="dates">
          <SegmentSelector
            labels={labels}
            setActiveIndex={setActiveIndex}
            activeIndex={activeIndex}
          />
        </div>
        {(sessions ?? []).map((item) => (
          <ScheduleItem key={item.sessionId} sessionId={item.sessionId} />
        ))}
      </div>
      <style jsx>
        {`
          .dates {
            display: flex;
            overflow-x: scroll;
          }
          .content {
            width: 100%;
            overflow: hidden;
            padding: 0 ${LightTheme.mainContentPadding}px;
          }
          #scheduleTitle {
            font-weight: bold;
            font-size: 1.5rem;
            color: #343434;
          }
          .scheduleContainer {
            background: #f7f8f8;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
          .scheduleHeader {
            margin: 0 0 30px 0;
          }
          .scheduleHeaderWrapper {
            flex-direction: column;
            display: flex;
            padding: 20px 20px 0 20px;
          }
        `}
      </style>
    </div>
  );
};
export default Schedule;
